import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
    selector       : 'error-404',
    templateUrl    : './error-404.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone     : true,
    imports        : [TranslocoPipe]
})
export class Error404Component
{
    /**
     * Constructor
     */
    constructor(
        private _location: Location
    )
    {
    }

    /**
     * Go to the last page
     */
    goBack(){
        this._location.back();
    }
}
